import { Dark } from './dark';
/**
 * Dark theme.
 */
export const ClassicDark = (options) => {
    return Object.assign({}, Dark(), {
        category10: 'category10',
        category20: 'category20',
    }, options);
};
ClassicDark.props = {};
//# sourceMappingURL=classicDark.js.map